import React, {useRef, useState} from "react";
import useOnClickOutside from "use-onclickoutside";
import {Link} from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";

import ActiveBooking from "./ActiveBooking";
import ArchivedBooking from "./ArchivedBooking";
import TrashBooking from "./TrashBooking";
import {openBookingEventLogsModal} from "../../../store/actions/bookingList";

const BookingList_Item_MoreDrop = ({booking}) => {
    const popupRef = useRef(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const hidePopup = () => setPopupOpen(false);
    useOnClickOutside(popupRef, hidePopup);
    const bookingListVars = useSelector(state => state.bookingList);
    const dispatch = useDispatch();

    const openEventLogs = (event) => {
        event.preventDefault();
        hidePopup();
        dispatch(openBookingEventLogsModal(booking));
    }

    const togglePopup = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setPopupOpen(!popupOpen);
    }

    return (
        <div className="more-options-drop d-flex" ref={popupRef}>
            <button type="button" className="dropdown-toggle dropdown-toggle-split" onClick={togglePopup}
                    id={`adm_dropdownMenuReference_${booking.id}`} data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false" data-reference="parent" >
                <span><i className="icon ico-more" /></span>
            </button>
            {popupOpen && <div className="dropdown-menu dropdown-menu-right show" aria-labelledby={`adm_dropdownMenuReference_${booking.id}`}>
                {bookingListVars.status !== 'active' &&
                    <ActiveBooking booking={booking} onClose={hidePopup}/>
                }
                {bookingListVars.status !== 'archived' &&
                    <ArchivedBooking booking={booking} onClose={hidePopup}/>
                }
                {bookingListVars.status !== 'trashed' &&
                    <TrashBooking booking={booking} onClose={hidePopup}/>
                }
                <a className="dropdown-item pointer" onClick={openEventLogs}>Activity log</a>
            </div>}
        </div>
    );
}

export default BookingList_Item_MoreDrop;